import superagent from 'superagent';
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';

export const startSession = createAsyncThunk(
	'session/startSession',
	(options, {getState}) => superagent
		.post(`${getState().status.engineUrl}/session/`)
		.send({
			FeatureModelId: getState().configuration.data.projects[0].project.featureModelId,
			Channel: getState().status.channel,
			variableRelationSetId:
				getState().status.family === 'LightProfile' ?
				null : (
					getState().status.mode === 'external' ?
						'dependency-step-wizard' : 'component-wizard'
					),
			UsageRuleParameters: {
				Now: new Date().toISOString(),
				RoleModelAdmin: 'admin',
				RoleInternalSales: 'internalSales',
			}
		})
		// .set('X-API-KEY', '5fef91ddb4b44813b17bf8487b0471d5') // added in proxy
		.set('X-Requested-With', 'XMLHttpRequest')
		.set('Accept', 'application/json')
		.then((response) => response.body)
		.catch((error) => error)
);

const sessionInitialState = {
	status: 'idle',
	sessionId: null,
	timeout: {
		absolute: null,
		slidingInSeconds: null,
		time: null,
	},
	error: {},
};
export const sessionSlice = createSlice({
	name: 'session',
	initialState: sessionInitialState,
	reducers: {
		slideTimeout: state => {
			state.timeout.time = (new Date().getTime()) + state.timeout.slidingInSeconds * 1000;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(startSession.fulfilled, (state, action) => {
			state.sessionId = action.payload.sessionId;
			state.timeout.absolute = Date.parse(action.payload.timeout.absolute);
			state.timeout.slidingInSeconds = action.payload.timeout.slidingInSeconds;
			state.timeout.time = (new Date().getTime()) + parseInt(action.payload.timeout.slidingInSeconds, 10) * 1000;
			state.status = 'idle';
			state.error = {};
		});
		builder.addCase(startSession.pending, (state, action) => {
			state.sessionId = null;
			state.status = 'loading';
			state.error = {};
		});
		builder.addCase(startSession.rejected, (state, action) => {
			state.sessionId = null;
			state.status = 'idle';
			state.error = action.payload;
		});
	}
});


export const {slideTimeout} = sessionSlice.actions;


export default sessionSlice.reducer;
